export const roundToDigits = (numberToRound: number, digits: number): number => {
  return Math.round(numberToRound * 10 ** digits) / 10 ** digits
}
